import React from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { useVideo } from "../../context";
import styles from "./uploadVideoForm.module.css";

const UplodVideoForm = () => {
  const { uploadVideoData, setUploadVideoData, uploadHandler } = useVideo();
  return (
    <div className={styles.videoUploadForm__wrapper}>
      <div className={styles.videoUpload__wrapper}>
        {uploadVideoData.video && (
          <video className={styles.videoUpload__source} controls>
            <source
              src={URL.createObjectURL(uploadVideoData.video)}
              type="video/mp4"
            />
          </video>
        )}
        {uploadVideoData.video ? (
          <button
            onClick={() =>
              setUploadVideoData((prev) => ({
                ...prev,
                video: "",
              }))
            }
            className={styles.remove__button}
          >
            <IoMdCloseCircle size="1.5rem"  title="remove" />
          </button>
        ) : (
          <input
            type="file"
            id="videoFile"
            accept="video/*"
            className={styles.videoUpload__input}
            onChange={(e) =>
              setUploadVideoData((prev) => ({
                ...prev,
                video: e.target.files[0],
              }))
            }
          />
        )}
      </div>
      <div className={styles.thumbnail__wrapper}>
        {uploadVideoData.thumbnail && (
          <img
            className={styles.thumbnail__img}
            src={URL.createObjectURL(uploadVideoData.thumbnail)}
            alt="avatar"
          />
        )}
        {uploadVideoData.thumbnail ? (
          <button
            onClick={() =>
              setUploadVideoData((prev) => ({
                ...prev,
                thumbnail: "",
              }))
            }
            className={styles.remove__button}
          >
            <IoMdCloseCircle size="1.5rem" title="remove" />
          </button>
        ) : (
          <input
            type="file"
            name="avatar"
            accept="image/png, image/jpeg"
            className={styles.thumbnail__input}
            onChange={(e) =>
              setUploadVideoData((prev) => ({
                ...prev,
                thumbnail: e.target.files[0],
              }))
            }
          />
        )}
      </div>
      <div className={styles.videoDetails__wrapper}>
        <div>
          <label htmlFor="title" className="input-label">
            Title:{" "}
          </label>
          <input
            id="title"
            type="text"
            className="form-field border-radius-xs padding-xs"
            placeholder="Title"
            required
            onChange={(e) =>
              setUploadVideoData((prev) => ({
                ...prev,
                title: e.target.value,
              }))
            }
            value={uploadVideoData.title}
          />
        </div>
        <div>
          <label htmlFor="description" className="input-label">
            Description:
          </label>
          <input
            id="description"
            type="text"
            className="form-field border-radius-xs padding-xs"
            placeholder="Description"
            required
            onChange={(e) =>
              setUploadVideoData((prev) => ({
                ...prev,
                description: e.target.value,
              }))
            }
            value={uploadVideoData.description}
          />
        </div>
      </div>
      <div className={styles.button__wrapper}>
        <button
          style={{ width: "95%" }}
          className="btn btn-primary border-radius-xs"
          onClick={uploadHandler}
        >
          Upload Video
        </button>
      </div>
    </div>
  );
};

export default UplodVideoForm;
